import browseFile from '../../browseFile'
import csvToJson from '../../csvToJson'
import unflatten from '../../unflatten'
import jsonToObject from '../../jsonToObject'
import BaseListPresenter from '../../base/BaseListPresenter'

class UserApplicationPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase)
    this.upsertUseCase = upsertUseCase
    this.exportCSVUseCase = exportCSVUseCase
    this.addSchemaUseCase = addSchemaUseCase
    this.updateSchemaUseCase = updateSchemaUseCase
    this.deleteSchemaUseCase = deleteSchemaUseCase
  }

  init() {
    this.limit = 10
    this.where = { status: 'Pending' }
    this.search = {}
    this.filter = {}
    this.include = ['all']
    this.sort = { createdAt: -1 }
    this.reset()
  }

  componentDidUpdate(prevProps) {
    const query = this.view.getQuery()
    if (query?.where && prevProps?.query?.where !== query?.where) {
      this.reset()
      this.where = JSON.parse(query.where)
      this.getObjects()
    }
  }

  async handleApplication(index, status) {
    const object = this.objects[index]
    object.status = status === 'Accepted' ? 'Accepted' : 'Rejected'
    const collection = this.view.getCollectionName()
    try {
      const data = await this.upsertUseCase.execute(collection, object)

      if (data.status === object.status) {
        this.objects[index] = object
        this.view.setObjects(this.objects)
      }

      console.log(data)
      const user = object.user
      if (data.typeOfApplication === 'Seller') {
        user.roles = [{ id: 'c0fd9661-f5eb-4a0b-a9e0-ceb3d5019fc0' }]
      } else if (data.typeOfApplication === 'Marketing Partner') {
        user.roles = [{ id: '57180cb0-180d-4c10-b858-45338d753f51' }]
      }

      await this.upsertUseCase.execute('users', user)
    } catch (error) {
      this.view.showError(error)
    }

    console.log(object)
  }
}

export default UserApplicationPresenter
